import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { useCurrency } from "../hook/useCurrency";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const currencyState = useCurrency();
  return (
    <CurrencyContext.Provider value={currencyState}>
      {children}
    </CurrencyContext.Provider>
  );
}

CurrencyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useCurrencyContext() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) {
    return {
      currency: "USD",
      rates: {},
      isLoading: true,
      setCurrency: () => {},
      formatProductPrice: (p) => p,
      convertToNumber: () => 0,
      supportedCurrencies: ["USD", "EUR", "GBP"],
      currencySymbols: { USD: "$", EUR: "\u20AC", GBP: "\u00A3" },
    };
  }
  return ctx;
}
